import React, { useEffect, useState, useRef, useCallback } from 'react';
import Image from 'next/image';
import { PicturesRecord } from '../../_types/productItem.types';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Divider from '@/components/UI/divider/Divider';
import Icon from '@/components/UI/icon/Icon';
import styles from './TopSliderGalleryFullHeight.module.scss';
type ITopSliderGalleryFullHeightProps = {
  handleOpenGallery: () => void;
  productImages: PicturesRecord[];
  clickedItemIndex?: number;
  handleFavorite?: () => void;
  isBookmarked?: boolean;
  handleOpenShare?: (name: string) => void;
};
const TopSliderGalleryFullHeight = ({
  handleOpenGallery,
  productImages,
  clickedItemIndex = 0,
  handleFavorite,
  isBookmarked,
  handleOpenShare
}: ITopSliderGalleryFullHeightProps) => {
  const images = productImages?.map(item => ({
    original: item.path,
    thumbnail: item.thumbnail_path,
    description: item?.caption || item?.title,
    originalAlt: item?.caption || item?.title
  }));
  const [index, setIndex] = useState<number>(clickedItemIndex);
  const galleryRef = useRef<ImageGallery>(null);
  const thumbsRef = useRef<HTMLDivElement>(null);
  const handleSlide = (index: number) => {
    setIndex(index);
  };
  const openShareHandler = () => {
    if (!handleOpenShare) return;
    handleOpenGallery();
    setTimeout(() => {
      handleOpenShare('SHARE');
    }, 200);
  };
  const centerThumb = useCallback((i?: number) => {
    const targetIndex = typeof i === 'number' ? i : index;
    const container = thumbsRef.current;
    if (!container) return;
    const activeThumb = container.querySelector(`[data-idx="${targetIndex}"]`) as HTMLElement | null;
    if (!activeThumb) return;
    const containerRect = container.getBoundingClientRect();
    const thumbRect = activeThumb.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;
    const thumbCenter = thumbRect.left + thumbRect.width / 2;
    const delta = thumbCenter - containerCenter;
    container.scrollBy({
      left: delta,
      behavior: 'smooth'
    });
  }, [index]);
  useEffect(() => {
    centerThumb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);
  return <>
      <Box className={styles['gallery']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeight.tsx">
        <Box className={styles['header-gallery']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeight.tsx">
          <Box onClick={() => handleOpenGallery()} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeight.tsx">
            <Icon name="arrow-right-1" type="highEmphasis" size={24} data-sentry-element="Icon" data-sentry-source-file="TopSliderGalleryFullHeight.tsx" />
          </Box>
          {handleFavorite || handleOpenShare ? <Box className={styles['share-save-container']}>
              {handleFavorite ? <Box onClick={handleFavorite}>
                  <Icon name={isBookmarked ? 'heart-Filled' : 'heart'} type={isBookmarked ? 'error' : 'highEmphasis'} size={24} />
                </Box> : null}
              {handleOpenShare ? <Box onClick={openShareHandler}>
                  <Icon name="share" type="highEmphasis" size={24} />
                </Box> : null}
            </Box> : <span />}
        </Box>

        <ImageGallery ref={galleryRef} items={images} lazyLoad showNav isRTL onSlide={handleSlide} startIndex={clickedItemIndex} showPlayButton={false} showFullscreenButton={false} showThumbnails={false} renderItem={(item: any) => {
        return <Box component={'figure'} className={styles['main-image']}>
                <Image src={item.original} alt={item.description || ''} width={1200} height={800} referrerPolicy="no-referrer" />
              </Box>;
      }} renderLeftNav={(onClick: any) => <Box onClick={onClick} className={styles['arrow-left-container']}>
              <Icon name="arrow-left-1" type="highEmphasis" size={'medium'} />
            </Box>} renderRightNav={(onClick: any) => <Box onClick={onClick} className={styles['arrow-right-container']}>
              <Icon name="arrow-right-2" type="highEmphasis" size={'medium'} />
            </Box>} data-sentry-element="ImageGallery" data-sentry-source-file="TopSliderGalleryFullHeight.tsx" />

        <Box ref={thumbsRef} dir="rtl" className={styles['gallery-thumbnail-wrapper']} component={'nav'} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeight.tsx">
          {images.map((img, id) => <button key={id} type="button" data-idx={id} className={`${styles['thumb']} ${id === index ? styles['active-thumb'] : ''}`} onClick={() => {
          galleryRef.current?.slideToIndex(id);
          centerThumb(id);
        }} aria-label={`نمایش تصویر ${id + 1}`}>
              <Image src={img.thumbnail} alt={img.description || ''} width={56} height={56} referrerPolicy="no-referrer" />
            </button>)}
        </Box>

        <Box className={styles['image-description']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeight.tsx">
          <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="TopSliderGalleryFullHeight.tsx">{`تصویر ${index + 1} از ${images.length}`}</Typography>
          {images[index]?.description && <>
              <Divider orientation="vertical" />
              <Typography variant="bodyM">
                {images[index]?.description}
              </Typography>
            </>}
        </Box>
      </Box>
    </>;
};
export default TopSliderGalleryFullHeight;